import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Upload",
  "use": "svg-icon-Upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-Upload\"><path fill-rule=\"evenodd\" d=\"M11 12H5V6H2l6-6 6 6h-3v6zM1 16v-2h14v2H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol